class SetSessionValues {
    constructor(postUrl) {
        this.postUrl = postUrl;
    }

    setSessionValues() {
        const params = new URLSearchParams(window.location.search);
        const data = [];

        // Check if "utm_source" or "utm_medium" is present
        const utmSource = params.get("utm_source");
        const utmMedium = params.get("utm_medium");

        if (utmSource) {
            data.push({ Key: "utm_source", value: utmSource });
        }
        if (utmMedium) {
            data.push({ Key: "utm_medium", value: utmMedium });
        }

        // Return if no relevant parameters are present
        if (data.length === 0) {
            return;
        }

        // Post the data to the server
        fetch(this.postUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(data)
        }).catch(error => {
            console.error(error);
        });
    }
}

new SetSessionValues("/api/forms/SetSessionValues").setSessionValues();